import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { PublicProductAPI } from '../../../../services/PublicProductAPI';
import Carousell from '../carousell'; 
import PublicProductCard from '../../../pages/products/Card/ProductCard';
import styles from './FeaturedProducts.module.css'; // Crie esse arquivo ou use o existente

const FeaturedProducts = () => {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    const fetchFeatured = async () => {
      try {
        const data = await PublicProductAPI.list_products({ signal: controller.signal });
        const filtered = data.filter(p => 
          (p.featured === true || p.featured === 1) && (p.is_active !== false)
        );
        setFeaturedProducts(filtered.slice(0, 6));
      } catch (e) {
        if (e.name === 'AbortError') return;
        console.error('Erro ao buscar destaques:', e);
      } finally {
        setLoading(false);
      }
    };
    fetchFeatured();
    return () => controller.abort();
  }, []);

  // Enquanto carrega, mostramos o esqueleto
  if (loading) {
    return (
      <Carousell title="PRODUTOS EM DESTAQUE" subtitle="OPERAÇÕES ESPECIAIS">
        {[...Array(4)].map((_, i) => (
          <div key={i} className={styles.skeletonCard} />
        ))}
      </Carousell>
    );
  }

  if (featuredProducts.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <Carousell title="PRODUTOS EM DESTAQUE" subtitle="OPERAÇÕES ESPECIAIS">
        {featuredProducts.map((product) => (
          <PublicProductCard key={product.id} product={product} />
        ))}
      </Carousell>
    </motion.div>
  );
};

export default FeaturedProducts;